import { makeAutoObservable } from 'mobx';
import { AnalysisTabKey } from './dish-data-shared.types';

/** 支持数据对比弹窗的页签。 */
type CompareDialogTab = Exclude<AnalysisTabKey, 'efficiency'>;

/** 父页面协调状态。 */
export class DishDataPageState {
    /** 当前激活页签。 */
    activeTab: AnalysisTabKey = 'extra';

    /** 当前打开的数据对比弹窗所属页签。 */
    compareDialogTab: CompareDialogTab | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    /**
     * 按页签 key 更新当前页签。
     * @param value - 页签 key
     */
    setActiveTab(value: AnalysisTabKey) {
        this.activeTab = value;
    }

    /**
     * 按页签索引更新当前页签。
     * @param index - 页签索引
     */
    setActiveTabByIndex(index: number) {
        /** 页签顺序数组。 */
        const tabOrder: AnalysisTabKey[] = ['extra', 'dish', 'efficiency'];
        this.activeTab = tabOrder[index] ?? 'extra';
    }

    /**
     * 打开指定页签的数据对比弹窗。
     * @param value - 弹窗所属页签
     */
    openCompareDialog(value: CompareDialogTab) {
        this.compareDialogTab = value;
    }

    /**
     * 关闭数据对比弹窗。
     */
    closeCompareDialog() {
        this.compareDialogTab = null;
    }

    /**
     * 获取当前页签索引。
     * @returns 页签索引
     */
    get activeTabIndex() {
        /** 页签顺序数组。 */
        const tabOrder: AnalysisTabKey[] = ['extra', 'dish', 'efficiency'];
        return tabOrder.indexOf(this.activeTab);
    }
}

export default DishDataPageState;
